import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';

import Button from '../../../../components/Button';

import './style.scss';
import { StickyButtons } from '../../../../components';

const TestimonialSidebar = ({ entities, footer, buttons }) => {
  const DEFAULT_LANGUAGE = config.get('DEFAULT_LANGUAGE');
  const { t } = useTranslation();
  const path = footer.getIn([0, 'entity', 'paths', DEFAULT_LANGUAGE], '');

  return (
    <div className="TestimonialSidebar">
      {entities.map((entity) => {
        const id = entity.getIn(['nid', '0', 'value']);
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);

        return (
          <Node
            id={id}
            key={`${uuid}:${langcode}`}
            entity={entity}
            viewMode="small"
          />
        );
      })}

      <StickyButtons>
        {buttons && (
          <div className="TestimonialSidebar__buttons">
            {buttons.map((button) => (
              <Button
                key={button.get('uri')}
                href={button.get('alias')}
              >
                {button.get('title')}
              </Button>
            ))}
          </div>
        )}
        <Button secondary href={path} className="TestimonialSidebar__more-link">
          {t('buttons.testimonialSidebarReadMore')}
        </Button>
      </StickyButtons>
    </div>
  );
};

export default TestimonialSidebar;
